import React from 'react'
import classNames from 'classnames'
import { useUniqueIds } from '../../utilities/general'
import Image from 'gatsby-image'
import Container from '../container'
import Row from '../row'
import Col from '../col'
import styles from './table.module.scss'
import shared from '../shared.module.scss'

const TableSlice = ({ slice }) => {
  const { items } = slice

  const {
    section_title,
    table_column_1_title,
    table_column_1_icon,
    table_column_2_title,
    table_column_2_icon,
    table_column_3_title,
    table_column_3_icon,
    table_column_4_title,
    table_column_4_icon,
    table_container_fluid,
    table_margin_bottom,
    table_text_color,
    table_background_color,
  } = slice.primary

  const itemsWithIds = useUniqueIds( items )

  return (
    <section
      className={ classNames( styles.section, {
        [ shared.margin ]: table_margin_bottom,
        [ shared.padding ]: table_background_color,
      }) }
      style={{
        color: table_text_color,
        backgroundColor: table_background_color,
      }}
    >
      <Container fluid={ table_container_fluid }>
        <h2 className={ styles.sectionTitle }>{ section_title.text }</h2>
        <table className={ styles.table }>
          <thead className={ styles.headers }>
            <tr>
              { ( table_column_1_title || table_column_1_icon.fluid ) && (
                <th className={ styles.header }>
                  { table_column_1_icon.fluid && (
                    <Image className={ classNames( styles.icon, ! table_column_1_title ? styles.iconTitle : '' ) } fluid={ table_column_1_icon.fluid } />
                  )}
                  
                  { table_column_1_title && (
                    <span className={ styles.title }>{ table_column_1_title }</span>
                  )}
                </th>
              )}

              { ( table_column_2_title || table_column_2_icon.fluid ) && (
                <th className={ styles.header }>
                  { table_column_2_icon.fluid && (
                    <Image className={ classNames( styles.icon, ! table_column_2_title ? styles.iconTitle : '' ) } fluid={ table_column_2_icon.fluid } />
                  )}

                  { table_column_2_title && (
                    <span className={ styles.title }>{ table_column_2_title }</span>
                  )}
                </th>
              )}

              { ( table_column_3_title || table_column_3_icon.fluid ) && (
                <th className={ styles.header }>
                  { table_column_3_icon.fluid && (
                    <Image className={ classNames( styles.icon, ! table_column_3_title ? styles.iconTitle : '' ) } fluid={ table_column_3_icon.fluid } />
                  )}
                  
                  { table_column_3_title && (
                    <span className={ styles.title }>{ table_column_3_title }</span>
                  )}
                </th>
              )}

              { ( table_column_4_title || table_column_4_icon.fluid ) && (
                <th className={ styles.header }>
                  { table_column_4_icon.fluid && (
                    <Image className={ classNames( styles.icon, ! table_column_4_title ? styles.iconTitle : '' ) } fluid={ table_column_4_icon.fluid } />
                  )}
                  
                  { table_column_4_title && (
                    <span className={ styles.title }>{ table_column_4_title }</span>
                  )}
                </th>
              )}
            </tr>
          </thead>

          <tbody className={ styles.body }>
            { !! itemsWithIds.length && itemsWithIds.map( item => (
              <tr key={ item.uniqueId } className={ styles.row }>
                { item.table_column_1_content.text && (
                  <td className={ styles.column } dangerouslySetInnerHTML={{ __html: item.table_column_1_content.html }} />
                )}

                { item.table_column_2_content.text && (
                  <td className={ styles.column } dangerouslySetInnerHTML={{ __html: item.table_column_2_content.html }} />
                )}

                { item.table_column_3_content.text && (
                  <td className={ styles.column } dangerouslySetInnerHTML={{ __html: item.table_column_3_content.html }} />
                )}

                { item.table_column_4_content.text && (
                  <td className={ styles.column } dangerouslySetInnerHTML={{ __html: item.table_column_4_content.html }} />
                )}
              </tr>
            ))}
          </tbody>
        </table>
        
        { !! itemsWithIds.length && itemsWithIds.map( item => (
          <Row key={ item.uniqueId } className={ styles.mobile }>
            { table_column_1_title ? (
              <>
                <Col span={ 5 }>
                  <div className={ styles.header }>
                    <span className={ styles.title }>{ table_column_1_title }</span>
                  </div>
                </Col>

                <Col span={ 7 }>
                  { item.table_column_1_content.text && (
                    <div dangerouslySetInnerHTML={{ __html: item.table_column_1_content.html }} />
                  )}
                </Col>
              </>
            ) : !! table_column_1_icon.fluid && (
              <>
                <Col span={ 5 }>
                  <div className={ styles.header }>
                    <Image className={ styles.icon } fluid={ table_column_1_icon.fluid } />
                  </div>
                </Col>

                <Col span={ 7 }>
                  { item.table_column_1_content.text && (
                    <div dangerouslySetInnerHTML={{ __html: item.table_column_1_content.html }} />
                  )}
                </Col>
              </>
            )}

            { table_column_2_title ? (
              <>
                <Col span={ 5 }>
                  <div className={ styles.header }>
                    <span className={ styles.title }>{ table_column_2_title }</span>
                  </div>
                </Col>

                <Col span={ 7 }>
                  { item.table_column_2_content.text && (
                    <div dangerouslySetInnerHTML={{ __html: item.table_column_2_content.html }} />
                  )}
                </Col>
              </>
            ) : !! table_column_2_icon.fluid && (
              <>
                <Col span={ 5 }>
                  <div className={ styles.header }>
                    <Image className={ styles.icon } fluid={ table_column_2_icon.fluid } />
                  </div>
                </Col>

                <Col span={ 7 }>
                  { item.table_column_2_content.text && (
                    <div dangerouslySetInnerHTML={{ __html: item.table_column_2_content.html }} />
                  )}
                </Col>
              </>
            )}

            { table_column_3_title ? (
              <>
                <Col span={ 5 }>
                  <div className={ styles.header }>
                    <span className={ styles.title }>{ table_column_3_title }</span>
                  </div>
                </Col>

                <Col span={ 7 }>
                  { item.table_column_3_content.text && (
                    <div dangerouslySetInnerHTML={{ __html: item.table_column_3_content.html }} />
                  )}
                </Col>
              </>
            ) : !! table_column_3_icon.fluid && (
              <>
                <Col span={ 5 }>
                  <div className={ styles.header }>
                    <Image className={ styles.icon } fluid={ table_column_3_icon.fluid } />
                  </div>
                </Col>

                <Col span={ 7 }>
                  { item.table_column_3_content.text && (
                    <div dangerouslySetInnerHTML={{ __html: item.table_column_3_content.html }} />
                  )}
                </Col>
              </>
            )}

            { table_column_4_title ? (
              <>
                <Col span={ 5 }>
                  <div className={ styles.header }>
                    <span className={ styles.title }>{ table_column_4_title }</span>
                  </div>
                </Col>

                <Col span={ 7 }>
                  { item.table_column_4_content.text && (
                    <div dangerouslySetInnerHTML={{ __html: item.table_column_4_content.html }} />
                  )}
                </Col>
              </>
            ) : !! table_column_4_icon.fluid && (
              <>
                <Col span={ 5 }>
                  <div className={ styles.header }>
                    <Image className={ styles.icon } fluid={ table_column_4_icon.fluid } />
                  </div>
                </Col>

                <Col span={ 7 }>
                  { item.table_column_4_content.text && (
                    <div dangerouslySetInnerHTML={{ __html: item.table_column_4_content.html }} />
                  )}
                </Col>
              </>
            )}
          </Row>
        ))}
      </Container>
    </section>
  )
}

export default TableSlice